import BaseModule from '../../BaseModule'
import logger from '../../config/logger'
import InviteService from './Service'

class Invite extends BaseModule {
  public static override clazz = 'Invite'

  public service!: InviteService

  public override run(): void {
    logger.log(`run module ${Invite.clazz}`)

    this.service = new InviteService(this.context)
  }
}

export default Invite
